'use strict';

var Sugar = require('sugar-core'),
    stringUnderscore = require('./internal/stringUnderscore');

Sugar.String.defineInstance({

  'dasherize': function(str) {
    return stringUnderscore(str).replace(/_/g, '-');
  }

});

module.exports = Sugar.String.dasherize;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/string/dasherize.js
// module id = 890
// module chunks = 0